<template>
  <article>
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
  </article>
</template>

<script>
export default {
  name: 'Description',

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>
